"use strict";

var _configuration = require("./configuration");
if (process.env.NODE_ENV === 'production') {
  // disable console in production mode
  if (!window.console) {
    window.console = {
      error: function error() {}
    };
  }
  var _console = window.console;
  _console.log = _console.info = _console.warn = _console.timeEnd = _console.time = _console.group = _console.groupEnd = function () {};
  // keep console.error to make them visible in prod too
} else {
  // eslint-disable-next-line no-console
  console.log('* dev mode, console is enabled.');
}
(0, _configuration.init)();